export default {
  'Start at': 'Mulai pada',
  'Set to current time': 'Atur ke waktu sekarang',
  'Audio volume': 'Volume audio',
  'Video volume': 'Volume video',
  'Trim audio': 'Pangkas audio',
  'Audio will end with the video': 'Audio akan berakhir bersama video.',
  'Trim': 'Pangkas',
}